import React, { useEffect, useLayoutEffect, useRef } from "react";
import ReactSignatureCanvas from "react-signature-canvas";
import { resizeCanvas } from "../common/interactiveCommon";
import Button from "react-bootstrap/Button";
const KS10Sign = (props) => {
  const { setSignatureData, setDateData, day1, day2, month1, month2, year3, year4 } = props;
  const signatureRef = useRef(null);
  const day1Ref = useRef(null);
  const day2Ref = useRef(null);
  const month1Ref = useRef(null);
  const month2Ref = useRef(null);

  const year3Ref = useRef(null);
  const year4Ref = useRef(null);
  useLayoutEffect(() => {
    resizeCanvas(signatureRef);
  }, []);

  useEffect(() => {
    if (props.signature === "" && signatureRef.current) {
      signatureRef.current.clear();
    }
  }, [props.signature]);
  const clearSignature = () => {
    signatureRef.current.clear();
    setSignatureData("");
  };

  const onDateChange = (e) => {
    let data = e.target.value;
    if (isNaN(Number(data))) {
      return;
    }
    switch (e.target.name) {
      case "day1":
        day2Ref.current.focus();
        break;
      case "day2":
        month1Ref.current.focus();
        break;
      case "month1":
        month2Ref.current.focus();
        break;
      case "month2":
        year3Ref.current.focus();
        break;
      case "year3":
        year4Ref.current.focus();
        break;
    }
    setDateData({ name: e.target.name, value: data });
  };

  return (
    <div className="row">
      <div className="mb-3 section-number-box col-sm-12 col-md-12 col-lg-12">
        <div className="mb-3 number">7.</div>
        <div className="details">
          <div className="form-group form-inline">
            <div className="section-label">
              <label className="">I wish to opt out of KiwiSaver</label>
            </div>
            <div className="section-form-group">
              <div className="section-form-group-inline col-12 col-md-12 col-lg-6 pr-3 pl-0 sign-wrapper">
                <div className="digital-signed mb-1">
                  <div className="digital-signed-name" style={{ width: "100%" }}>
                    <ReactSignatureCanvas
                      penColor="black"
                      backgroundColor="white"
                      // canvasProps={{ height: 90, width: 750 }}
                      ref={signatureRef}
                      onEnd={() => {
                        const imageData = signatureRef.current.getTrimmedCanvas().toDataURL("image/png");
                        setSignatureData(imageData);
                      }}
                    />
                  </div>
                </div>
                <div className="clear-signature d-flex">
                  <small className="small-title-label d-flex">Signature </small>
                  <Button
                    variant="outline-secondary"
                    onClick={clearSignature}>
                    Clear signature
                  </Button>
                </div>
              </div>
              <div className="section-form-group-inline pr-1">
                <input
                  maxLength="1"
                  placeholder="d"
                  type="text"
                  id="day1"
                  name="day1"
                  className="form-control text-center "
                  ref={day1Ref}
                  value={day1}
                  onChange={onDateChange}
                />
                <input
                  maxLength="1"
                  placeholder="d"
                  type="text"
                  id="day2"
                  name="day2"
                  className="form-control text-center mr-1 "
                  ref={day2Ref}
                  value={day2}
                  onChange={onDateChange}
                />

                <small className="small-title-label d-flex justify-content-center">Day</small>
              </div>
              <div className="section-form-group-inline pr-1">
                <input
                  maxLength="1"
                  placeholder="m"
                  type="text"
                  id="month1"
                  name="month1"
                  className="form-control text-center"
                  ref={month1Ref}
                  value={month1}
                  onChange={onDateChange}
                />
                <input
                  maxLength="1"
                  placeholder="m"
                  type="text"
                  id="month2"
                  name="month2"
                  className="form-control text-center mr-1"
                  ref={month2Ref}
                  value={month2}
                  onChange={onDateChange}
                />

                <small className="small-title-label d-flex justify-content-center">Month </small>
              </div>
              <div className="section-form-group-inline">
                <input
                  maxLength="1"
                  type="text"
                  id="year1"
                  name="year1"
                  className="form-control text-center"
                  value="2"
                  disabled
                />
                <input
                  maxLength="1"
                  type="text"
                  id="year2"
                  name="year2"
                  className="form-control text-center"
                  value="0"
                  disabled
                />
                <input
                  maxLength="1"
                  placeholder="y"
                  type="text"
                  id="year3"
                  name="year3"
                  className="form-control text-center"
                  ref={year3Ref}
                  value={year3}
                  onChange={onDateChange}
                  required={true}
                />
                <input
                  maxLength="1"
                  placeholder="y"
                  type="text"
                  id="year4"
                  name="year4"
                  className="form-control text-center"
                  ref={year4Ref}
                  value={year4}
                  onChange={onDateChange}
                  required={true}
                />
                <small className="small-title-label d-flex justify-content-center">Year</small>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default KS10Sign;
